import type { IService } from '../../shared';
import type { HighlightMaterial } from './types';

export class TextHighlightService implements IService {
    private highlights = new Map<string, HighlightMaterial>();

    onInit(): void {}

    /**
     * 全量替换内存素材目录，不触发加载或重绘
     *
     * @param highlights - 业务获取的完整素材列表，同 ID 的后项覆盖前项
     */
    setHighlights(highlights: HighlightMaterial[]): void {
        this.highlights = new Map(highlights.map((highlight) => [highlight.id, highlight]));
    }

    /**
     * 按素材身份读取业务登记的原对象
     *
     * @param id - 素材 ID
     * @returns 对应素材；未登记时返回 undefined
     */
    getHighlight(id: string): HighlightMaterial | undefined {
        return this.highlights.get(id);
    }

    onUnmount(): void {
        this.highlights.clear();
    }
}
